import { CalendarTimeSlotsIntro } from '../components/calendar-time-slots-intro';
import { FormattedTimeSlotsList } from '~/components/calendar-with-filters/time-slots/time-slots-list';
import { formatFittedBedroomsSlots as formatTimeSlots } from '~/components/calendar-with-filters/time-slots/helpers';

export const config = {
  Calendar: {
    calendarTimeSlotsIntro: CalendarTimeSlotsIntro,
    timeSlotsList: FormattedTimeSlotsList,
    timeSlotSectionTitle: 'Choose a time slot',
    formatTimeSlots,
  },
};
